import React from "react";
import { Icon } from "@chakra-ui/react";
import {
  MdHome,
  MdLock,
  MdPhoneIphone,
  MdLocalBar,
  MdAccessTime,
  MdCategory,
  MdLocalMall,
  MdReceiptLong,
  MdFactCheck,
  MdPrint,
} from "react-icons/md";

import Events from "views/admin/events";
import MenuItem from "views/admin/menuItem";
import DrinkMenu from "views/admin/drinkMenu";
import HappyHourMenu from "views/admin/happyHourMenu";
import MenuCategories from "views/admin/menuCategories";
import BrunchMenu from "views/admin/brunchMenu";
import Merch from "views/admin/merch";
import Reservation from "views/admin/reservations";
import BlackCard from "views/admin/blackCard";
import GameSpecials from "views/admin/gameSpecials";
import PrivateBooking from "views/admin/privateBooking";
import NotificationsAdmin from "views/admin/notifications";
import MobileHome from "views/admin/mobileHome";
import Orders from "views/admin/orders";
import AuditLogs from "views/admin/auditLogs";
import PrinterHealth from "views/admin/printerHealth";
import SignInCentered from "views/auth/signIn";

const routes = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignInCentered,
  },

  {
    name: "Events",
    layout: "/admin",
    path: "/events",
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: Events,
    allowedRoles: ["admin"],
  },
  {
    category: true,
    name: "Menus",
    allowedRoles: ["admin"],
    items: [
      {
        name: "Menu",
        layout: "/admin",
        path: "/menu",
        icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
        component: MenuItem,
        allowedRoles: ["admin"],
      },
      {
        name: "Drink Menu",
        layout: "/admin",
        path: "/drink-menu",
        icon: (
          <Icon as={MdLocalBar} width="20px" height="20px" color="inherit" />
        ),
        component: DrinkMenu,
        allowedRoles: ["admin"],
      },
      {
        name: "Happy Hour Menu",
        layout: "/admin",
        path: "/happy-hour-menu",
        icon: (
          <Icon as={MdAccessTime} width="20px" height="20px" color="inherit" />
        ),
        component: HappyHourMenu,
        allowedRoles: ["admin"],
      },
      {
        name: "Brunch Menu",
        layout: "/admin",
        path: "/brunch-menu",
        icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
        component: BrunchMenu,
        allowedRoles: ["admin"],
      },
      {
        name: "Menu Categories",
        layout: "/admin",
        path: "/menu-categories",
        icon: (
          <Icon as={MdCategory} width="20px" height="20px" color="inherit" />
        ),
        component: MenuCategories,
        allowedRoles: ["admin"],
      },
      {
        name: "Merch",
        layout: "/admin",
        path: "/merch",
        icon: (
          <Icon as={MdLocalMall} width="20px" height="20px" color="inherit" />
        ),
        component: Merch,
        allowedRoles: ["admin"],
      },
    ],
  },
  {
    category: true,
    name: "Specials",
    allowedRoles: ["admin"],
    items: [
      {
        name: "Game Specials",
        layout: "/admin",
        path: "/game-specials",
        icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
        component: GameSpecials,
        allowedRoles: ["admin"],
      },
      {
        name: "Black Card",
        layout: "/admin",
        path: "/black-card",
        icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
        component: BlackCard,
        allowedRoles: ["admin"],
      },
      {
        name: "Sky Lounge",
        layout: "/admin",
        path: "/private-booking",
        icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
        component: PrivateBooking,
        allowedRoles: ["admin"],
      },
    ],
  },
  {
    category: true,
    name: "Operations",
    allowedRoles: ["admin", "employee"],
    items: [
      {
        name: "Orders",
        layout: "/admin",
        path: "/orders",
        icon: (
          <Icon as={MdReceiptLong} width="20px" height="20px" color="inherit" />
        ),
        component: Orders,
        allowedRoles: ["admin", "employee"],
      },
      {
        name: "Reservation",
        layout: "/admin",
        path: "/reservation",
        icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
        component: Reservation,
        allowedRoles: ["admin", "employee"],
      },
      {
        name: "Printer Health",
        layout: "/admin",
        path: "/printer-health",
        icon: (
          <Icon as={MdPrint} width="20px" height="20px" color="inherit" />
        ),
        component: PrinterHealth,
        allowedRoles: ["admin", "employee"],
      },
      {
        name: "Notifications",
        layout: "/admin",
        path: "/notifications",
        icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
        component: NotificationsAdmin,
        allowedRoles: ["admin"],
      },
      {
        name: "Mobile App Home",
        layout: "/admin",
        path: "/mobile-home",
        icon: (
          <Icon as={MdPhoneIphone} width="20px" height="20px" color="inherit" />
        ),
        component: MobileHome,
        allowedRoles: ["admin"],
      },
      {
        name: "Audit Logs",
        layout: "/admin",
        path: "/audit-logs",
        icon: (
          <Icon as={MdFactCheck} width="20px" height="20px" color="inherit" />
        ),
        component: AuditLogs,
        allowedRoles: ["admin"],
      },
    ],
  },
];

export default routes;
